export const profile = process.env.REACT_APP_PROFILE;
let HOST = "dev-api.globlin.io";
if (profile === "dev") HOST = "dev-api.globlin.io";
else if (profile === "prod") HOST = "api.globlin.io";
export { HOST };
